import { RBCheck } from '@lfw/roesberg';
import { TranslateService } from '@ngx-translate/core';
import { v4 as uuidv4 } from 'uuid';

export class MenuCommand {
  readonly id = uuidv4();
  icon = '';
  route = '';
  transId = '';
  customText = '';
  needProject = false;
  isExternalRoute = false;

  constructor(private readonly translateService: TranslateService) {}

  get text(): string {
    if (!RBCheck.isNullOrEmpty(this.customText)) {
      return this.customText;
    }
    return this.translateService.instant('COMMANDS.' + this.transId.toUpperCase());
  }
}
